module.exports = __webpack_public_path__ + "img/motor_no27.08dfccb0.jpg";